import { ErrorResponse } from "../../api";
import { capacitySlice } from "../../features/UsageBased_Capacity/store";
import { commonSlice, store } from "../../store";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";

export async function selectCapacities(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());
    const state = store.getState();
    const capacitiesAPI = api.getCapacityAPI();
    let officeId: number | undefined;
    if (state.common.selectedOfficeId > 0) {
        officeId = state.common.selectedOfficeId;
    }

    let officeIds = state.common.officeIds;
    if (officeId) {
        officeIds = [officeId];
    }

    try {
        const result = await capacitiesAPI.getCapacities({
            officeIds: officeIds,
            officeId: officeId,
            driverId: state.common.selectedDriver?.driverId,
        });
        store.dispatch(
            capacitySlice.actions.updateCapacities(result.capacities!)
        );

        sendLog(
            ResourceType.CAPACITY_SELECT,
            StatusType.GET_RESOURCE,
            ActionType.SELECT_CAPACITY
        );
    } catch (err) {
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}

export async function updateCapacities(
    officeId: number,
    driverId: number,
    capTrips: number
): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());
    const capacitiesAPI = api.getCapacityAPI();

    try {
        const row = await capacitiesAPI.updateCapacity({
            officeId,
            driverId,
            capTrips,
        });
        store.dispatch(capacitySlice.actions.updateSelectedCapacity(row));
        const state = store.getState();

        sendLog(
            ResourceType.CAPACITY_SET,
            StatusType.GET_RESOURCE,
            ActionType.SET_CAPACITY
        );
    } catch (err) {
        console.log("Setting capacities error:", err);
        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        console.log("Capacity set");
        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }

        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
